import { withStyles } from '@mui/styles';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from '@mui/material/TableSortLabel';
import React from "react";
import * as styleGlobal from "../infra/styleGlobal";
class TableDesktop extends React.Component {
  constructor(props) {
    super(props);

    let key = "";
    if (props.sorters) {
      props.sorters.forEach(element => {
        if (element.nome == props.orderInicial && element.key) {
          key = element.key;
        }
      });
    }
    this.state = {
      sorter: props.sorterInicialSorter ? props.sorterInicialSorter : "asc",
      order: key,
      descorder: props.orderInicial
    }
  }


  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this)
      this.props.funcLista(1)
    }
  }
  componentWillUnmount() {
    if (this.props.onRef) {
      // this.props.onRef(undefined)
    }
  }




  getActiveSorterOrder() {
    return { sorter: this.state.sorter, order: this.state.order, descorder: this.state.descorder }
  }

  testesCustonsSorter(prop, sorters) {

    let retorno = false;
    sorters.forEach(element => {
      if (element.nome == prop && element.key && !element.disableSorter) {
        retorno = true;
      }
    });

    return retorno;

  }
  isEven(value) {
    if (value % 2 == 0)
      return true;
    else
      return false;
  }


  rows() {
    let { classes, tableData = [] } = this.props;
    let data = tableData.data ? tableData.data : tableData;
    return data.map((prop, key) => {
      // let stylerow = { backgroundColor: (this.isEven(key) ? styleGlobal.color7 : 'white') }
      let stylerow = { backgroundColor: 'white' }
      if (tableData.rowStyle) {
        stylerow = { ...stylerow, ...tableData.rowStyle(prop) }
      }
      return (
        <TableRow style={stylerow} key={key}>
          {prop.map((prop, key) => { return (<TableCell className={classes.tableCell} key={key}>{prop}</TableCell>); })}
        </TableRow>
      );
    })
  }

  render() {
    let { classes, tableHead = [], tableData = [], sorters, sortHandler } = this.props;
    let { sorter, descorder } = this.state;
    return (
      <div className={classes.tableResponsive}>
        <Table className={classes.table}>
          {tableHead !== undefined ? (
            <TableHead className={classes.tableHeadKothe}>
              <TableRow>
                {tableHead.map((prop, key) => {
                  if (sorters && this.testesCustonsSorter(prop, sorters)) {
                    return (
                      <TableCell
                        className={classes.tableCell + " " + classes.tableHeadCell}
                        key={key}
                      >
                        <TableSortLabel
                          active={descorder == prop}
                          className={classes.tableHeadCell}
                          direction={sorter}
                          onClick={() => {
                            let key = "";
                            sorters.forEach(element => {
                              if (element.nome == prop && element.key) {
                                key = element.key;
                              }
                            });
                            this.setState({ descorder: prop, order: key, sorter: sorter == "desc" ? "asc" : "desc" }, () => {
                              sortHandler(prop, this.state.sorter, key)
                            })
                          }}
                        >
                          {prop}
                        </TableSortLabel>
                      </TableCell>
                    );
                  } else {
                    return (<TableCell className={classes.tableCell + " " + classes.tableHeadCell} key={key}>   {prop}</TableCell>);
                  }
                })}
              </TableRow>
            </TableHead>
          ) : null}
          <TableBody>
            {this.rows()}
          </TableBody>
        </Table>
      </div>
    );
  }
}


const defaultFont = {

  color: 'black !important',
  lineHeight: "1.5em"
};

const tableStyle = theme => ({
  table: {
    marginBottom: "0",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderSpacing: "0",
    borderCollapse: "collapse"
  },
  tableHeadCell: {
    ...defaultFont,
    fontWeight: "bold",
    fontSize: "1em"
  },
  tableCell: {
    ...defaultFont,
    lineHeight: "1.42857143",
    padding: "12px 8px",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
  },
  tableResponsive: {
    width: "100%",
    marginTop: 5,
    overflowX: "auto",
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,

  },
  tableHeadKothe: {
    backgroundColor: styleGlobal.color8,
    borderTopRightRadius: 15,
    borderTopLeftRadius: 15,
  }
});
export default withStyles(tableStyle)(TableDesktop);
